import { List } from 'immutable';
import I18n from 'I18n';
import TimeRange from 'MeetingsBase/models/TimeRange';
import { unify } from 'MeetingsBase/utils/TimeRangeListUtils';
import { validTimeRange } from 'MeetingsBase/utils/dates';
import { AVAILABILITY_OPTIONS, WEEKDAYS_LIST, AVAILABLE_DAYS } from 'MeetingsBase/constants/dates';
export default class Availability {
  constructor(props = {}) {
    const keys = Object.keys(AVAILABILITY_OPTIONS);
    for (const key of keys) {
      this[key] = props[key] !== undefined ? props[key] : [];
    }
  }
  static from(json) {
    if (!json) {
      return new Availability();
    }
    const result = {};
    const keys = Object.keys(AVAILABILITY_OPTIONS);
    for (const key of keys) {
      const rawRanges = json[key];
      result[key] = rawRanges ? rawRanges.map(TimeRange.from).filter(validTimeRange).sort((a, b) => a.end - b.end) : [];
    }
    return new Availability(result);
  }
  static _fromWithoutValidation(json) {
    if (!json) {
      return new Availability();
    }
    const result = {};
    const keys = Object.keys(AVAILABILITY_OPTIONS);
    for (const key of keys) {
      const rawRanges = json[key];
      result[key] = rawRanges ? rawRanges.map(TimeRange.from).sort((a, b) => a.end - b.end) : [];
    }
    return new Availability(result);
  }
  isValid() {
    return Object.keys(AVAILABILITY_OPTIONS).every(option => this[option].every(timeRange => validTimeRange(timeRange)));
  }
  isEmpty() {
    return Object.keys(AVAILABILITY_OPTIONS).every(option => this[option].length === 0);
  }

  // Returns List<TimeRange> for backward compat with callers in utils.ts
  getForDateString(dateString) {
    const weekDayIndex = I18n.moment(dateString).day();
    return this.getForWeekDayIndex(weekDayIndex);
  }
  getUnmergedForWeekDay(weekDay) {
    const self = this;
    switch (weekDay) {
      case AVAILABLE_DAYS.SATURDAY:
      case AVAILABLE_DAYS.SUNDAY:
        return [...self[weekDay], ...self[AVAILABILITY_OPTIONS.SAT_SUN], ...self[AVAILABILITY_OPTIONS.EVERY_DAY]];
      case AVAILABLE_DAYS.MONDAY:
      case AVAILABLE_DAYS.TUESDAY:
      case AVAILABLE_DAYS.WEDNESDAY:
      case AVAILABLE_DAYS.THURSDAY:
      case AVAILABLE_DAYS.FRIDAY:
        return [...self[weekDay], ...self[AVAILABILITY_OPTIONS.MON_FRI], ...self[AVAILABILITY_OPTIONS.EVERY_DAY]];
      default:
        return [...self[weekDay], ...self[AVAILABILITY_OPTIONS.EVERY_DAY]];
    }
  }

  // Returns List<TimeRange> — unify() still takes List (converted in Phase 5)
  getForWeekDayIndex(index) {
    const weekDay = WEEKDAYS_LIST[index];
    const unmergedAvailabilityForWeekDay = this.getUnmergedForWeekDay(weekDay);
    return unify(List(unmergedAvailabilityForWeekDay));
  }
  setForWeekDayIndex(availability, index) {
    return new Availability(Object.assign({}, this, {
      [WEEKDAYS_LIST[index]]: availability
    }));
  }
  convertToJSON() {
    const self = this;
    const keys = Object.keys(AVAILABILITY_OPTIONS);
    const result = {};
    for (const key of keys) {
      result[key] = self[key].map(range => range.toJSON());
    }
    return result;
  }
}